@if (!searchResult.isLoading) {
  <button class="container" mat-button type="button" (click)="handleClick()">
    <div>
      <img [src]="searchResult.iconUrl" alt="" />
      <strong>{{ searchResult.name }}</strong>
    </div>
    <img src="assets/svg/plan-manager/chevron-right.svg" alt="" />
  </button>
} @else {
  <div class="skeleton-load"></div>
}
